module.exports = __webpack_public_path__ + "img/cv-downarrow.2bd15f9b.svg";